function createNavigate(setRoute, setParams) {
  return (route, params = {}) => {
    setRoute(route);
    setParams(params);
  };
}

export { createNavigate };
